import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_helpers/auth.guard';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
const loginModule = () => import('./login/login.component').then((x) => x.LoginComponent)
const dashboardModule = () => import('./dashboard/dashboard.component').then((x) => x.DashboardComponent)
const homeModule = () => import('./home-page/home-page.component').then((x) => x.HomePageComponent)
const mapMdoule = () => import('./map-container/map-container.component').then((x) => x.MapContainerComponent)
const welcomeModule = () => import('./welcome-page/welcome-page.component').then((x) => x.WelcomePageComponent)

// Food
const viewcartModule = () => import('./Food/view-cart/view-cart.module').then((x) => x.ViewCartModule)
const FoodMenuModule = () => import('./Food/food-menu-list/food-menu-list.module').then((x) => x.FoodMenuListModule)
const FoodSearchModule = () => import('./Food/food-search-list/food-search-list.module').then((x) => x.FoodSearchListModule)

const FoodHomeModule = () => import('./Food/food-home//food-home.module').then((x) => x.FoodHomeListModule)
const PaymentModule = () => import('./Food/payment/payment.module').then((x) => x.PaymentModule)
const FoodOrderDetailsModule = () => import('./Food/order-details/order-details.module').then((x) => x.OrderDetailsModule)
const FoodDetailsModule = () => import('./Food/food-details/food-details.module').then((x) => x.FoodDetailsModule)
const FoodMenuSearchModule = () => import('./Food/food-menu-search/food-menu-search.module').then((x) => x.FoodMenuSearchModule)

// Laundry
const LaundryHomeModule = () => import('./Laundry/laundry-home/laundry-home.module').then((x) => x.LaundryHomeModule)
const LaundryMenuModule = () => import('./Laundry/laundry-menu-list/laundry-menu.module').then((x) => x.LaundryMenuModule)
const LaundryCartModule = () => import('./Laundry/laundry-cart/laundry-cart.module').then((x) => x.LaundryCartModule)
const LaundryPaymentModule = () => import('./Laundry/laundry-payment/laundry-payment.module').then((x) => x.LaundryPaymentModule)
const LaundryOrderModule = () => import('./Laundry/laundry-order-details/laundry-order-details.module').then((x) => x.LaundryOrderModule)


//RoomService
const RoomServiceMenuModule = () => import('./RoomService/room-service-menu/room-service.module').then((x) => x.RoomServiceModule)
const RoomServiceCartModule = () => import('./RoomService/room-service-cart/room-service-cart.module').then((x) => x.RoomServiceCartModule)
const RoomServicepaymentModule = () => import('./RoomService/room-service-payment/room-service-payment.moule').then((x) => x.RoomServicePaymentModule)
const RoomOrderDetails = () => import('./RoomService/room-service-order-details/room-service-order-details.module').then((x) => x.RoomServiceOrderModule)


// Order
const orderDetails = () => import('./order-details/order-details/order-details.module').then((x) => x.OrderDetailsModule)
const YourOrderModule = () => import('./order-details/my-order-details/my-order-details.module').then((x) => x.MyOrderModule)

// Profile
const ProfileModule = () => import('./Profile/profile.module').then((x) => x.ProfileModule)

const routes: Routes = [
  {
    path: 'login',
    loadComponent: loginModule
  },
  {
    path: 'dashboard',
    loadComponent: dashboardModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'home',
    loadComponent: homeModule,
    // canActivate: [AuthGuard]
  },
  {
    path: 'welcome',
    loadComponent: welcomeModule,
    // canActivate: [AuthGuard]
  },
  {
    path: 'map',
    loadComponent: mapMdoule,
    canActivate: [AuthGuard]
  },

  // Food
  {
    path: 'food',
    loadChildren: FoodHomeModule,
    // canActivate: [AuthGuard]
  },
  {
    path: 'food-menu',
    loadChildren: FoodMenuModule,
    // canActivate: [AuthGuard]
  },
  {
    path: 'food-list-search',
    loadChildren: FoodMenuSearchModule,
    // canActivate: [AuthGuard]
  },
  {
    path: 'food-search',
    loadChildren: FoodSearchModule,
    // canActivate: [AuthGuard]
  },
  {
    path: 'food-cart',
    loadChildren: viewcartModule,
    // canActivate: [AuthGuard]
  },
  {
    path: 'food-payment',
    loadChildren: PaymentModule,
    // canActivate: [AuthGuard]
  },
  {
    path: 'food-order',
    loadChildren: FoodOrderDetailsModule,
    // canActivate: [AuthGuard]
  },
  {
    path: 'food-details',
    loadChildren: FoodDetailsModule,
    // canActivate: [AuthGuard]
  },

  // Laundry
  {
    path: 'laundry',
    loadChildren: LaundryHomeModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'laundry-menu',
    loadChildren: LaundryMenuModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'laundry-cart',
    loadChildren: LaundryCartModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'laundry-payment',
    loadChildren: LaundryPaymentModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'laundry-order',
    loadChildren: LaundryOrderModule,
    canActivate: [AuthGuard]
  },

  // Room Service
  {
    path: 'room-service',
    loadChildren: RoomServiceMenuModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'room-cart',
    loadChildren: RoomServiceCartModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'room-payment',
    loadChildren: RoomServicepaymentModule,
    canActivate: [AuthGuard]
  },

  {
    path: 'service-order',
    loadChildren: RoomOrderDetails,
    canActivate: [AuthGuard]
  },
  {
    path: 'profile',
    loadChildren: ProfileModule,
    canActivate: [AuthGuard]
  },
  {
    path: 'order-details',
    loadChildren: orderDetails,
    canActivate: [AuthGuard]
  },
  {
    path: 'your-order',
    loadChildren: YourOrderModule,
    canActivate: [AuthGuard]
  },

  {
    path: 'auth-callback',
    component: AuthCallbackComponent
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
